export const cover = {
  title: 'PROJECT-TITLE',
  subtitle: 'PROJECT-AUDIENCE',
  heading: 'Treinamento Corporativo',
  image: 'THEME_FOLDER/1450101499163-c8848c66ca85.jpg'
}
